import { create } from 'zustand';

type AfterPurchaseModalState = {
  buttonText?: string;
  description: string;
  invoiceUrl?: string;
  isError: boolean;
  isOpen: boolean;
  isPending: boolean;
  showInvoiceLink: boolean;
};

type AfterPurchaseModalActions = {
  close: () => void;
  openError: (description: string, invoiceUrl?: string, buttonText?: string) => void;
  openProcessing: (args?: { invoiceUrl?: string }) => void;
  openSuccess: (description: string, showInvoiceLink?: boolean) => void;
  setInvoiceUrl: (invoiceUrl: string) => void;
};

type AfterPurchaseModalStore = AfterPurchaseModalActions & AfterPurchaseModalState;

const DEFAULT_STATE: AfterPurchaseModalState = {
  buttonText: '',
  description: '',
  invoiceUrl: '',
  isError: false,
  isOpen: false,
  isPending: false,
  showInvoiceLink: false,
};

export const useAfterPurchaseModalStore = create<AfterPurchaseModalStore>((set) => ({
  ...DEFAULT_STATE,
  close: () => set(DEFAULT_STATE),
  openError: (description: string, invoiceUrl?: string, buttonText?: string) =>
    set({
      buttonText,
      description,
      invoiceUrl,
      isError: true,
      isOpen: true,
      isPending: false,
      showInvoiceLink: !!invoiceUrl || !!buttonText,
    }),
  openProcessing: (args?: { invoiceUrl?: string }) =>
    set({
      buttonText: '',
      description: '',
      invoiceUrl: args?.invoiceUrl ?? '',
      isError: false,
      isOpen: true,
      isPending: true,
      showInvoiceLink: !!args?.invoiceUrl,
    }),
  openSuccess: (description: string, showInvoiceLink = false) =>
    set({
      buttonText: '',
      description,
      invoiceUrl: '',
      isError: false,
      isOpen: true,
      isPending: false,
      showInvoiceLink,
    }),
  setInvoiceUrl: (invoiceUrl: string) => set({ invoiceUrl, showInvoiceLink: !!invoiceUrl }),
}));
